// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2_Lc0","errorLogs":"EditorFooter_errorLogs__14tRK"};